<template>
  <v-card-title>
    <slot name="menu"></slot>
    <div class="titleContainer">
      <v-tooltip
        v-if="canAccess(access.SHARED, accessLevel)"
        location="bottom"
        :max-width="600"
        :disabled="!isNameOverflowing()"
      >
        <template v-slot:activator="{ props }">
          <div
            ref="deviceName"
            v-bind="props"
            class="device-name"
            :class="{
              'device-name__public': isAccess(access.SHARED, accessLevel),
              mobile: xs
            }"
          >
            <span>{{ name }}</span>
          </div>
        </template>
        <span>{{ name }}</span>
      </v-tooltip>
      <div v-else class="device-name__public" data-cy="devicePopoverName">
        {{ $t('map.popover.publicDevice') }}
      </div>
      <div
        class="device-type"
        :class="{
          'device-type__public':
            isAccess(access.NONE, accessLevel) || isAccess(access.SHARED, accessLevel)
        }"
      >
        {{ deviceType }}
      </div>
      <div
        v-if="serial"
        class="device-serial"
        :class="{ 'device-serial__shared': isAccess(access.SHARED, accessLevel) }"
        data-cy="devicePopoverSerial"
      >
        {{ serial }}
      </div>
    </div>
    <v-spacer></v-spacer>
    <div v-if="canAccess(access.FULL, accessLevel)">
      <slot name="status"></slot>
    </div>
  </v-card-title>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useDisplay } from 'vuetify'
import { useAccess } from '@/services/device-access'
import { isChildOverflowing } from '@/services/html-utilities'

export default defineComponent({
  name: 'PopoverTitle',
  setup() {
    const { xs } = useDisplay()
    const { access, canAccess, isAccess } = useAccess()

    return {
      xs,
      access,
      canAccess,
      isAccess
    }
  },
  props: {
    accessLevel: {
      type: Number,
      default: 0
    },
    deviceType: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    serial: {
      type: String,
      default: ''
    }
  },
  methods: {
    isNameOverflowing(): boolean {
      const ref = this.$refs.deviceName as HTMLElement | HTMLElement[] | undefined
      if (!ref) {
        return false
      }
      return isChildOverflowing(ref)
    }
  }
})
</script>

<style lang="scss" scoped>
.v-card-title {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  min-height: 42px;
  padding: 0 4px;
  font-size: 15px;

  .titleContainer {
    display: flex;
    flex-direction: column;
    padding-bottom: 4px;
    overflow: hidden;

    .device-name {
      font-size: 16px;
      margin-right: 4px;
      margin-left: 4px;
      height: 22px;
      line-height: 26px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &__public {
        margin-right: 4px;
        margin-left: 12px;
        height: 22px;
        line-height: 26px;
      }

      &.mobile {
        font-size: 15px;
      }
    }
    .device-type,
    .device-serial {
      margin-left: 4px;
      height: 12px;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);

      &__public,
      &__shared {
        margin-left: 12px;
      }
    }
  }
}
</style>
